import Vue from 'vue'

import Element from 'element-ui'
import './styles/element-variables.scss'
import '@/views/risk/moduleSet/decisionTree/index.css'

import '@/styles/index.scss' // global css
import '@/assets/custom-font/index.css' //自定义字体
import App from './App'
import store from './store'
import router from './router'
import * as utils from '@/utils'
import request from '@/utils/request'
import JsonViewer from 'vue-json-viewer'
Vue.use(JsonViewer)

import 'vue-json-viewer/style.css'
import './permission'
import * as filters from './filters' // global filters
import * as validate from '@/utils/validate'
import './utils/dialogDrag'

import FieldSelect from './components/FieldSelect'
import RosterField from './components/FieldSelect/rosterField'

import './styles/ui.scss'

Vue.component('FieldSelect',FieldSelect)
Vue.component('RosterField', RosterField)

Vue.prototype.uuid = function() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
          v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
  });
}

import 'highlight.js/styles/agate.css'
import hljs from 'highlight.js'
Vue.directive('highlight',{
  inserted: el => {
      let blocks = el.querySelectorAll('pre code');
      blocks.forEach( (block) => {
          hljs.highlightBlock(block);
      });
  },
  componentUpdated: el => {
      let blocks = el.querySelectorAll('pre code');
      blocks.forEach( (block) => {
          hljs.highlightBlock(block);
      });
  },
})

Vue.use(Element, {
  size: 'medium'
})

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.prototype.utils=utils
Vue.prototype.request=request
Vue.prototype.validate=validate
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  var hasSpaceId=!!(localStorage.getItem('space-info'));
  const NeedSpaceId=!(to.meta.notNeedSpaceId);
  if(NeedSpaceId) localStorage.spaceNextTitle=to.meta.title;
  if(!hasSpaceId&&NeedSpaceId){
    Element.Message('请先选择工作空间')
    router.push("/dashboard")
    return
  }
  next()
})


new Vue ({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js